import React from "react";
import { Link } from "react-router-dom";
import { Phone, MessageCircle, Mail, MapPin, Clock, Instagram, Youtube } from "lucide-react";
import Logo from "@/components/Logo";
import { SITE, waLink, telLink } from "@/lib/site-config";

const Footer = () => {
  return (
    <footer
      className="relative border-t border-[rgba(255,255,255,0.14)] bg-[#556340] pt-20 pb-28 md:pb-12"
      data-testid="site-footer"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <Logo size={64} showWordmark={false} />
            <p className="mt-6 text-sm text-[#C9C6B4] leading-relaxed max-w-md">
              NNR Coaching. Nachhaltiges Krafttraining, Ernährung, Regeneration
              und Mindset – individuell auf dein Leben zugeschnitten. Mit
              echter Betreuung und ehrlichem WhatsApp-Support.
            </p>
            <div className="mt-6 flex items-center gap-3">
              <a
                href={SITE.contact.social.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center rounded-full border border-[rgba(255,255,255,0.2)] hover:bg-black/[0.04] transition-colors"
                aria-label="Instagram"
                data-testid="footer-instagram"
              >
                <Instagram size={16} />
              </a>
              <a
                href={SITE.contact.social.youtube}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center rounded-full border border-[rgba(255,255,255,0.2)] hover:bg-black/[0.04] transition-colors"
                aria-label="YouTube"
                data-testid="footer-youtube"
              >
                <Youtube size={16} />
              </a>
            </div>
          </div>

          <div className="md:col-span-4">
            <div className="text-[11px] font-bold uppercase tracking-[0.22em] text-[#A8A58F] mb-5">
              Kontakt
            </div>
            <ul className="space-y-3 text-sm text-[#E5E2D0]">
              <li>
                <a
                  href={telLink()}
                  className="flex items-center gap-3 hover:text-[#E8E5D0] transition-colors"
                  data-testid="footer-phone"
                >
                  <Phone size={14} className="text-[#A8A58F]" />
                  {SITE.contact.phoneDisplay}
                </a>
              </li>
              <li>
                <a
                  href={waLink()}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-3 hover:text-[#25D366] transition-colors"
                  data-testid="footer-whatsapp"
                >
                  <MessageCircle size={14} className="text-[#A8A58F]" />
                  WhatsApp Chat
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${SITE.contact.email}`}
                  className="flex items-center gap-3 hover:text-[#E8E5D0] transition-colors"
                  data-testid="footer-email"
                >
                  <Mail size={14} className="text-[#A8A58F]" />
                  {SITE.contact.email}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin size={14} className="text-[#A8A58F] mt-0.5" />
                <span>
                  {SITE.contact.address.street}
                  <br />
                  {SITE.contact.address.zip} {SITE.contact.address.city}
                </span>
              </li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="text-[11px] font-bold uppercase tracking-[0.22em] text-[#A8A58F] mb-5">
              Öffnungszeiten
            </div>
            <ul className="space-y-2 text-sm text-[#C9C6B4]">
              <li className="flex items-center gap-2">
                <Clock size={12} className="text-[#8F8C7A]" />
                <span className="text-[#E5E2D0]">Immer geöffnet</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-[#556340] flex flex-col md:flex-row md:items-center justify-between gap-4 text-xs text-[#A8A58F]">
          <div>
            © {new Date().getFullYear()} {SITE.brand.fullName}. Alle Rechte vorbehalten.
          </div>
          <div className="flex items-center gap-5">
            <Link
              to="/impressum"
              className="hover:text-[#F3F1E8] transition-colors"
              data-testid="footer-impressum"
            >
              Impressum
            </Link>
            <Link
              to="/datenschutz"
              className="hover:text-[#F3F1E8] transition-colors"
              data-testid="footer-datenschutz"
            >
              Datenschutz
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
